import React from 'react';
import {List, Map} from 'immutable';
import cn from 'classnames';
import {Speaker, TopicMatch} from '@store/call-card/CallCard.types';
import {UserAvatar} from '@components/util/UserAvatar';
import './WideTranscriptLine.sass';
import formatSecondsShort from 'utils/formatSecondsShort';
import {TopicId} from '@store/topic-keyword/TopicKeyword.types';
import {Color, Seconds} from '@store/@types/util';
import {boldMatchText} from '@components/call-card/TranscriptMatch.utils';

interface WideTranscriptLineProps {
  chunk: string;
  startTime: Seconds;
  speaker: Speaker | undefined;
  matches: List<TopicMatch>;
  activeTopics: Map<TopicId, Color>;
  onClick: () => void;
  authUserId?: string;
  highlightLine: boolean;
}

export const WideTranscriptLine: React.FC<WideTranscriptLineProps> = ({
  speaker,
  startTime,
  chunk,
  authUserId,
  matches,
  activeTopics,
  onClick,
  highlightLine,
}) => {
  const isInternal = !!speaker?.userId;
  const isAuthUser = authUserId && speaker?.userId === authUserId;
  const colors = matches.map(m => activeTopics.get(m.id)!).toSet();

  return (
    <div
      onClick={onClick}
      className={cn(`wide-transcript-line transcript-line-${Math.floor(startTime)}`, {
        internal: isInternal,
        'auth-user': isAuthUser,
        highlight: highlightLine,
      })}>
      <div className="speaker-info">
        <UserAvatar user={speaker} />
        <span className="speaker-name">{speaker?.description ?? 'Unidentified Speaker'}</span>
      </div>
      <div className="message-wrapper">
        <div className="message">
          <span
            className="chunk"
            dangerouslySetInnerHTML={{__html: boldMatchText(chunk, matches)}}
          />
          &nbsp;
          <span className="timestamp">{formatSecondsShort(startTime)}</span>
        </div>
        <div className="match-bars">
          {colors.map(c => (
            <div className="match-bar" style={{backgroundColor: c}} />
          ))}
        </div>
      </div>
    </div>
  );
};
